var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import CBForm from '@cb/apricot/CBForm';
import cn from 'classnames';
import { useUID } from 'react-uid';
export const FileUpload = forwardRef((_a, ref) => {
    var { id, name, label = 'Choose File', btnClassName, disabled = false, className, btnType, btnSize = 'sm', btnId, fdbk = true, fdbkPath = false, fdbkMsg = 'No file selected...', fdbkTruncate = true, fdbkMaxChars = 'auto', fdbkRemove = true, fdbkPosition = 'middle', fdbkId, ellipseText = '...', onFileSelected, onFileRemoved, cbRef } = _a, props = __rest(_a, ["id", "name", "label", "btnClassName", "disabled", "className", "btnType", "btnSize", "btnId", "fdbk", "fdbkPath", "fdbkMsg", "fdbkTruncate", "fdbkMaxChars", "fdbkRemove", "fdbkPosition", "fdbkId", "ellipseText", "onFileSelected", "onFileRemoved", "cbRef"]);
    const inputEl = useRef(null);
    useImperativeHandle(ref, () => inputEl.current);
    useEffect(() => {
        // initialize the apricot fileUpload plugin
        const apricotFileUpload = CBForm.fileUpload({
            elem: inputEl.current,
            markup: false,
            fdbk,
            fdbkPath,
            fdbkMsg,
            fdbkTruncate,
            fdbkMaxChars,
            fdbkRemove,
            fdbkPosition,
            ellipseText,
        });
        // custom event when a file has been selected
        inputEl.current.addEventListener('apricot_fileSelected', e => {
            onFileSelected && onFileSelected(e);
        });
        // custom event when selected file has been removed
        inputEl.current.addEventListener('apricot_fileRemoved', e => {
            onFileRemoved && onFileRemoved(e);
        });
        if (cbRef) {
            // eslint-disable-next-line no-param-reassign
            cbRef.current = apricotFileUpload;
        }
        return () => {
            apricotFileUpload === null || apricotFileUpload === void 0 ? void 0 : apricotFileUpload.destroy();
        };
    }, []);
    const uid = useUID();
    const inputId = id || `apricot_input_file_${uid}`;
    const buttonClassName = cn('cb-file-button', btnType ? `cb-btn cb-btn-${btnType}` : 'cb-btn', btnSize ? `cb-btn-${btnSize}` : null, btnClassName);
    return (React.createElement("div", { className: cn('cb-file-upload', className), "data-cbtrack-comp": "apricot-react:file-upload" },
        React.createElement("input", Object.assign({ type: "file", ref: inputEl, id: inputId, name: name, disabled: disabled }, props)),
        React.createElement("button", { type: "button", className: buttonClassName, disabled: disabled, id: btnId }, label),
        React.createElement("span", { id: fdbkId, className: "cb-file-element" })));
});
//# sourceMappingURL=FileUpload.js.map